import { render, staticRenderFns } from "./DefaultFreightInput.vue?vue&type=template&id=0865c861&scoped=true&"
import script from "./DefaultFreightInput.vue?vue&type=script&lang=js&"
export * from "./DefaultFreightInput.vue?vue&type=script&lang=js&"
import style0 from "./DefaultFreightInput.vue?vue&type=style&index=0&id=0865c861&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0865c861",
  null
  
)

export default component.exports